<template>
  <div class="configRelation h100">
    <el-card>
      <el-steps :active="active" simple>
        <el-step title="1.配置关系创建" icon="el-icon-setting"></el-step>
        <el-step title="2.权重配置" icon="el-icon-edit"></el-step>
        <el-step title="3.结果预览、发布" icon="el-icon-view"></el-step>
      </el-steps>
      <el-card class="box-card" shadow="never">
        <div v-if="active === 0">
          <create-config ref="createConfigRef" ></create-config>
          <el-row type="flex" justify="end">
              <el-button type="primary" @click="createConfirm()">下一步</el-button>
          </el-row>
        </div>
        <div v-if="active === 1">
          <kpi-table ref="weightConfigRef" :kpiConfigList="kpiConfigList" :canEditWeight="true" :hasOperation="true"></kpi-table>
          <el-row type="flex" justify="end">
            <el-button type="primary" @click="configSaveReset()">上一步</el-button>
            <el-button type="primary" @click="configSave()">下一步</el-button>
          </el-row>
        </div>
        <div v-if="active === 2">
          <kpi-table :kpiConfigList="kpiConfigList" :canEditWeight="false" :hasOperation="false"></kpi-table>
          <el-row type="flex" justify="end">
            <el-button type="primary" @click="configPublishReset()">上一步</el-button>
            <el-button type="primary" @click="configPublish()">发布</el-button>
          </el-row>
        </div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import CreateConfig from './createConfig.vue'
// kpitable公用
import kpiTable from './kpiTable'

export default {
  name: 'configRelation',
  components: {
    kpiTable,
    CreateConfig
  },
  data () {
    return {
      active: 0,
      kpiConfigList: [],
      bonusVersionList: {},
      editData: this.$route.params.editData ? this.$route.params.editData : [], // 接受跳转的数据
      selectedData: [], // 选中的KPI
      kpiOverall: [], // 存储所有KPI
      oldData: [],
      newData: []
    }
  },
  created () {
    // console.log(this.editData)
  },
  mounted () {
    this.jumpData()
  },
  methods: {
    // 1下一步
    createConfirm () {
      // 调用子组件concat方法连接数组赋值selectedData
      this.$refs.createConfigRef.$refs.chooseKpiRef.concat()
      // 赋值bonusVersionList
      this.bonusVersionList = this.$refs.createConfigRef.bonusVersionList
      // 赋值子组件selectedData
      this.selectedData = this.$refs.createConfigRef.$refs.chooseKpiRef.selectedData
      // console.log(this.selectedData)
      // 排序
      this.selectedData.sort(this.mysort)
      if (this.bonusVersionList.year !== null && this.bonusVersionList.channel !== null && this.bonusVersionList.position !== null) {
        // KPI全部列表参数--新添加
        let bonusVersionList = {}
        bonusVersionList.year = this.bonusVersionList.year
        bonusVersionList.channelId = this.bonusVersionList.channel.split('^')[0]
        bonusVersionList.positionId = this.bonusVersionList.position.split('^')[0]
        // console.log(bonusVersionList)
        this.getKpiList(bonusVersionList)
      } else {
        this.$message.warning('年份、渠道、职位为必选！')
      }
    },
    // 2下一步
    configSave () {
      let weight = []
      let kpiConfigList = this.kpiConfigList
      // console.log(kpiConfigList)
      kpiConfigList.forEach(ele => {
        if (ele.kpiWeight !== '' && typeof (ele.kpiWeight) !== 'undefined' && ele.kpiWeight !== null) {
          // weight.push(ele.kpiWeight)
          weight.push({
            quarter: ele.quarter,
            kpiType: ele.kpiType,
            kpiWeight: ele.kpiWeight
          })
        }
      })
      // console.log(weight)
      let kpiWight = kpiConfigList.filter(ele => {
        return ele.kpiType === '季度考核' || ele.kpiType === '年度考核'
      })
      if (weight.length === kpiWight.length) {
        let newList = []
        weight.forEach(function (el) {
          for (var i = 0; i < newList.length; i++) {
            if (newList[i].quarter === el.quarter) {
              newList[i].child.push({
                kpiWeight: el.kpiWeight
              })
              return
            }
          }
          newList.push({
            quarter: el.quarter,
            child: [{
              kpiWeight: el.kpiWeight
            }]
          })
        })
        // console.log(newList)
        let success = false
        for (let i = 0; i < newList.length; i++) {
          let num = 0
          // let key = ''
          for (let j = 0; j < newList[i].child.length; j++) {
            num += Number(newList[i].child[j].kpiWeight)
          }
          // console.log(num)
          if (num !== 100) {
            this.$message.error(`${newList[i].quarter}相加不等于100%`)
            success = false
            return false
          } else {
            success = true
          }
        }
        if (success) {
          this.active = 2
        }
        // console.log(this.kpiConfigList)
      } else {
        this.$message.error('请配置KPI权重！')
      }
    },
    // 2上一步
    configSaveReset () {
      setTimeout(() => {
        // 控制在调用--初始化KPI列表
        this.$refs.createConfigRef.isBack = false
        // 权重
        let bonusVersionList = this.bonusVersionList
        bonusVersionList.channel = bonusVersionList.channel.split('^')[1]
        bonusVersionList.position = bonusVersionList.position.split('^')[1]
        this.$refs.createConfigRef.bonusVersionList = bonusVersionList
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ1 = this.selectedValue(this.kpiConfigList, 'Q1', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ2 = this.selectedValue(this.kpiConfigList, 'Q2', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ3 = this.selectedValue(this.kpiConfigList, 'Q3', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ4 = this.selectedValue(this.kpiConfigList, 'Q4', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ5 = this.selectedValue(this.kpiConfigList, 'Yearly', '年度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA1 = this.selectedValue(this.kpiConfigList, 'Q1', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA2 = this.selectedValue(this.kpiConfigList, 'Q2', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA3 = this.selectedValue(this.kpiConfigList, 'Q3', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA4 = this.selectedValue(this.kpiConfigList, 'Q4', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA5 = this.selectedValue(this.kpiConfigList, 'Yearly', '附加')
      }, 0)
      this.active = 0
    },
    // 3下一步
    configPublish () {
      // console.log(this.kpiConfigList)
      this.$http.post(this.API.bonusVersionKpiMappingSaveBatch, this.kpiConfigList).then(res => {
        let data = res.data
        if (data.code === 200) {
          this.$message({
            message: '发布成功！',
            type: 'success'
          })
        } else {
          this.$message({
            message: '发布失败！',
            type: 'error'
          })
        }
      })
    },
    // 3上一步
    configPublishReset () {
      setTimeout(() => {
        // console.log(this.$refs)
        // disabled禁用
        this.$refs.weightConfigRef.$refs.kpiRuleRef.viewDisabled = 'false'
        // this.$refs.weightConfigRef.$refs.kpiRuleRef.backValueFlag = 'true'
        // this.$refs.weightConfigRef.$refs.kpiRuleRef.data = this.$refs.weightConfigRef.$refs.kpiRuleRef.dataCopy
        // console.log(this.$refs.weightConfigRef.$refs.kpiRuleRef.data)
      }, 0)
      this.active = 1
    },
    // 跳转赋值
    jumpData () {
      if (this.editData.length > 0) {
        // console.log(this.editData)
        this.$refs.createConfigRef.isBack = true
        // 赋值奖金版本
        this.$refs.createConfigRef.bonusVersionList = {
          year: this.editData[0].year,
          channel: this.editData[0].channel,
          position: this.editData[0].position }
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ1 = this.selectedValue(this.editData, 'Q1', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ2 = this.selectedValue(this.editData, 'Q2', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ3 = this.selectedValue(this.editData, 'Q3', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ4 = this.selectedValue(this.editData, 'Q4', '季度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueQ5 = this.selectedValue(this.editData, 'Yearly', '年度考核')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA1 = this.selectedValue(this.editData, 'Q1', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA2 = this.selectedValue(this.editData, 'Q2', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA3 = this.selectedValue(this.editData, 'Q3', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA4 = this.selectedValue(this.editData, 'Q4', '附加')
        this.$refs.createConfigRef.$refs.chooseKpiRef.selectedValueA5 = this.selectedValue(this.editData, 'Yearly', '附加')
      }
    },
    // 分发数据
    selectedValue (arr, quarter, kpiType) {
      let kpiData = []
      arr.forEach(ele => {
        if (ele.quarter === quarter && ele.kpiType === kpiType) {
          kpiData.push(ele.kpi)
        }
      })
      return kpiData
    },
    // 排序-季度和类型
    mysort (a, b) {
      if (a.quarter !== b.quarter) {
        return a.quarter < b.quarter ? -1 : 1
      } else {
        return a.kpiType - b.kpiType
      }
    },
    // 获取KPI配置列表--全部列表
    getKpiList (data) {
      this.kpiOverall = []
      // 选中的KPI
      let selectedData = []
      this.selectedData.forEach(ele => {
        selectedData.push({
          year: this.bonusVersionList.year,
          channel: this.bonusVersionList.channel.split('^')[1],
          channelId: this.bonusVersionList.channel.split('^')[0],
          position: this.bonusVersionList.position.split('^')[1],
          positionId: this.bonusVersionList.position.split('^')[0],
          quarter: ele.quarter,
          kpiType: ele.kpiType,
          kpi: ele.kpiName
        })
      })
      // console.log(selectedData)
      this.$http.post(this.API.kpiOverviewList, data).then((res) => {
        let data = res.data
        // console.log(data)
        if (data.code === 200) {
          let transfer = data.data
          if (transfer.length > 0) {
            this.kpiOverall = transfer
            // console.log(this.kpiOverall)
            this.getCommonDataOld(selectedData, this.kpiOverall)
            this.getCommonDataNew(selectedData, this.kpiOverall)
            let kpiConfigList = this.oldData.concat(this.newData)
            kpiConfigList.sort(this.mysort)
            this.kpiConfigList = []
            // 处理小数点
            kpiConfigList.forEach(ele => {
              if (ele.kpiWeight) {
                ele.kpiWeight = ele.kpiWeight === null ? null : this.Tools.formatNumber(ele.kpiWeight, 0, 0)
              }
            })
            this.kpiConfigList = kpiConfigList
            // console.log(this.kpiConfigList)
          } else {
            this.kpiOverall = []
            this.kpiConfigList = []
            this.kpiConfigList = selectedData
          }
          if (this.kpiConfigList.length > 0) {
            this.active = 1
          } else {
            this.$message.error('请配置KPI关系！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    getCommonDataOld (arr1, arr2) {
      let newArr = []
      arr1.forEach(e1 => {
        arr2.forEach(e2 => {
          if (e1.quarter === e2.quarter && e1.kpiType === e2.kpiType && e1.kpi === e2.kpi) {
            newArr.push(e2)
          }
        })
      })
      // console.log(newArr)
      this.oldData = newArr
    },
    getCommonDataNew (arr1, arr2) {
      let newArr = []
      let isExist = false
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].quarter === arr2[j].quarter && arr1[i].kpiType === arr2[j].kpiType && arr1[i].kpi === arr2[j].kpi) {
            // console.log(arr1[i].quarter)
            isExist = true
            break
          } else {
            isExist = false
          }
        }
        // console.log(isExist)
        if (!isExist) {
          newArr.push(arr1[i])
        }
      }
      // console.log(newArr)
      this.newData = newArr
    }
  }
}
</script>

<style lang="less" scoped>
.box-card {
  margin-top: 20px;
}
.el-row {
  margin-top: 10px;
}
// 表单行高影响子组件
/deep/ .el-form-item__content {
  line-height: 36px;
}
</style>
